document.documentElement.classList.add('js');

const homeRevealElements = [...document.querySelectorAll('[data-home-title-reveal], [data-home-logo-reveal]')];

if (homeRevealElements.length > 0) {
  const showElement = (element) => element.classList.add('is-visible');

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        showElement(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.15,
    });

    homeRevealElements.forEach((element) => revealObserver.observe(element));
  } else {
    homeRevealElements.forEach(showElement);
  }
}

const siteHeader = document.querySelector('[data-site-header]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

if (siteHeader instanceof HTMLElement) {
  let previousScrollY = window.scrollY;
  let animationFrame = 0;

  const updateHeader = () => {
    const currentScrollY = Math.max(window.scrollY, 0);
    const difference = currentScrollY - previousScrollY;
    const menuIsOpen = mobileMenu instanceof HTMLDetailsElement && mobileMenu.open;
    const headerHasFocus = siteHeader.contains(document.activeElement);

    if (currentScrollY <= 16 || difference < -4 || menuIsOpen || headerHasFocus) {
      siteHeader.classList.remove('-translate-y-full');
    } else if (difference > 4 && currentScrollY > siteHeader.offsetHeight) {
      siteHeader.classList.add('-translate-y-full');
    }

    if (Math.abs(difference) > 4) previousScrollY = currentScrollY;
    animationFrame = 0;
  };

  window.addEventListener('scroll', () => {
    if (animationFrame === 0) animationFrame = window.requestAnimationFrame(updateHeader);
  }, { passive: true });

  siteHeader.addEventListener('focusin', () => siteHeader.classList.remove('-translate-y-full'));
}

if (mobileMenu instanceof HTMLDetailsElement) {
  mobileMenu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => mobileMenu.removeAttribute('open'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu.open) {
      mobileMenu.removeAttribute('open');
      mobileMenu.querySelector('summary')?.focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (mobileMenu.open && event.target instanceof Node && !mobileMenu.contains(event.target)) {
      mobileMenu.removeAttribute('open');
    }
  });
}

const galleryDialog = document.querySelector('[data-gallery-dialog]');
const galleryPreviews = [...document.querySelectorAll('[data-gallery-preview]')];

if (typeof HTMLDialogElement !== 'undefined' && galleryDialog instanceof HTMLDialogElement && galleryPreviews.length > 0) {
  const dialogImage = galleryDialog.querySelector('[data-gallery-dialog-image]');
  const dialogTitle = galleryDialog.querySelector('[data-gallery-dialog-title]');
  const dialogCounter = galleryDialog.querySelector('[data-gallery-counter]');
  const originalLink = galleryDialog.querySelector('[data-gallery-original]');
  const closeButton = galleryDialog.querySelector('[data-gallery-close]');
  const previousButton = galleryDialog.querySelector('[data-gallery-previous]');
  const nextButton = galleryDialog.querySelector('[data-gallery-next]');
  let activeIndex = 0;

  const showPreview = (index) => {
    activeIndex = (index + galleryPreviews.length) % galleryPreviews.length;
    const preview = galleryPreviews[activeIndex];
    const title = preview.dataset.galleryTitle ?? '';

    dialogImage.src = preview.href;
    dialogImage.alt = title;
    dialogImage.width = Number(preview.dataset.galleryWidth) || 0;
    dialogImage.height = Number(preview.dataset.galleryHeight) || 0;
    dialogTitle.textContent = title;
    dialogCounter.textContent = `${activeIndex + 1} / ${galleryPreviews.length}`;
    originalLink.href = preview.href;
  };

  galleryPreviews.forEach((preview, index) => {
    preview.addEventListener('click', (event) => {
      event.preventDefault();
      showPreview(index);
      galleryDialog.showModal();
    });
  });

  closeButton.addEventListener('click', () => galleryDialog.close());
  previousButton.addEventListener('click', () => showPreview(activeIndex - 1));
  nextButton.addEventListener('click', () => showPreview(activeIndex + 1));

  galleryDialog.addEventListener('click', (event) => {
    if (event.target === galleryDialog) galleryDialog.close();
  });

  galleryDialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') showPreview(activeIndex - 1);
    if (event.key === 'ArrowRight') showPreview(activeIndex + 1);
  });

  galleryDialog.addEventListener('close', () => {
    dialogImage.removeAttribute('src');
  });
}

if (__DEV__) {
  const events = new EventSource('/__dev/events');

  events.addEventListener('reload', () => window.location.reload());
  events.addEventListener('build-error', (event) => {
    console.error('[dev] Build nie powiodl sie:', event.data);
  });
}
